import React, { useEffect } from 'react'

import {
  Box,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { isEmpty } from 'lodash'

import useStyles from './styles'

const Question = ({ quizQuestionTemplate }) => {
  const { control, errors, watch, setValue, register } = useFormContext()
  const classes = useStyles()

  const questionAlternativeId = watch('questionAlternativeId')

  useEffect(() => {
    register({ name: 'hasJustification' })
  }, [register])

  useEffect(() => {
    if (questionAlternativeId) {
      const observationsRequired =
        quizQuestionTemplate?.questionAlternatives?.find(
          (alternative) =>
            String(alternative.id) === String(questionAlternativeId),
        )?.observationsRequired ?? false

      setValue('hasJustification', observationsRequired)
    }
    // eslint-disable-next-line
  }, [questionAlternativeId, quizQuestionTemplate])

  return (
    <Paper
      component={Box}
      p={2}
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography variant="h4" color="primary">
        {quizQuestionTemplate?.theme}
      </Typography>
      <Typography variant="subtitle1" color="primary">
        {quizQuestionTemplate?.question}
      </Typography>
      <Typography variant="body1" color="primary">
        {quizQuestionTemplate?.explanation}
      </Typography>
      {!isEmpty(quizQuestionTemplate?.evidences) && (
        <Box display="flex" flexDirection="column" gridGap={8}>
          <Typography variant="h6" color="primary">
            Evidências Exigidas:
          </Typography>
          {quizQuestionTemplate.evidences.map((evidence, index) => (
            <Typography key={index} variant="body1" color="primary">
              {index + 1}. {evidence.title}
            </Typography>
          ))}
        </Box>
      )}
      <FormControl>
        <Controller
          control={control}
          name="questionAlternativeId"
          as={
            <RadioGroup>
              {quizQuestionTemplate?.questionAlternatives?.map(
                (alternative) => (
                  <FormControlLabel
                    key={alternative.id}
                    value={String(alternative.id)}
                    control={<Radio />}
                    label={
                      <Typography
                        variant="body1"
                        className={classes.optionTitle}
                      >
                        {alternative.title}
                      </Typography>
                    }
                  />
                ),
              )}
            </RadioGroup>
          }
        />
      </FormControl>
      {!!errors?.questionAlternativeId && (
        <Typography variant="body2" color="error">
          {errors.questionAlternativeId.message || 'Selecione uma alternativa'}
        </Typography>
      )}
      <Controller
        control={control}
        name="justification"
        as={
          <TextField
            label="Justificativa (Comentário)"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            error={!!errors?.justification}
            helperText={errors?.justification?.message}
          />
        }
      />
    </Paper>
  )
}

export default Question
